(function stickyCheckoutInit() {
  const CHECKOUT_VISITED_KEY = 'cc-has-reached-checkout';
  const REMINDER_DISMISSED_KEY = 'cc-cart-reminder-dismissed';

  const stickyCheckoutModal = document.querySelector('[data-sticky-checkout]');

  const safeSetStorage = (storage, key, value) => {
    try {
      storage.setItem(key, value);
    } catch (err) {
      // Ignore storage errors (private mode, blocked storage, etc.)
    }
  };

  const safeGetStorage = (storage, key) => {
    try {
      return storage.getItem(key);
    } catch (err) {
      return null;
    }
  };

  const safeRemoveStorage = (storage, key) => {
    try {
      storage.removeItem(key);
    } catch (err) {
      // Ignore storage errors.
    }
  };

  const setCheckoutVisited = () => {
    safeSetStorage(localStorage, CHECKOUT_VISITED_KEY, 'true');
    safeRemoveStorage(localStorage, REMINDER_DISMISSED_KEY);
  };
  const hasReachedCheckout = () => safeGetStorage(localStorage, CHECKOUT_VISITED_KEY) === 'true';
  const clearCheckoutVisited = () => safeRemoveStorage(localStorage, CHECKOUT_VISITED_KEY);

  const isCheckoutTriggerElement = (element) => {
    if (!element) return false;
    if (element.closest('a[href*="/checkout"], a[href*="/checkouts/"]')) return true;
    if (element.closest('[name="checkout"]')) return true;
    return false;
  };

  const isCheckoutSubmit = (form, submitter) => {
    if (!form) return false;
    if (submitter && submitter.name === 'checkout') return true;
    const action = (form.getAttribute('action') || '').toLowerCase();
    return action.includes('/checkout') || action.includes('/checkouts/');
  };

  document.addEventListener(
    'click',
    (event) => {
      if (!isCheckoutTriggerElement(event.target)) return;
      setCheckoutVisited();
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const submitter = event.submitter || document.activeElement;
      if (!isCheckoutSubmit(event.target, submitter)) return;
      setCheckoutVisited();
    },
    true
  );

  if (!stickyCheckoutModal) return;
  if (document.body.classList.contains('template-cart')) return;

  const closeTriggers = stickyCheckoutModal.querySelectorAll('[data-sticky-checkout-close]');
  const ctaLink = stickyCheckoutModal.querySelector('[data-sticky-checkout-cta]');
  const thumbsWrap = stickyCheckoutModal.querySelector('[data-sticky-checkout-thumbs]');
  const countEl = stickyCheckoutModal.querySelector('[data-sticky-checkout-count]');
  const totalEl = stickyCheckoutModal.querySelector('[data-sticky-checkout-total]');

  const checkoutUrl = stickyCheckoutModal.getAttribute('data-checkout-url') || '/checkout';

  const hasPlacedOrder = () => {
    const currentUrl = `${window.location.pathname}${window.location.search}`.toLowerCase();
    const referrer = (document.referrer || '').toLowerCase();
    const orderPlacedPattern = /\/thank_you|\/orders\/|order_status|\/order-received/;
    return orderPlacedPattern.test(currentUrl) || orderPlacedPattern.test(referrer);
  };

  const lockPageScroll = () => {
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.body.style.touchAction = 'none';
  };

  const unlockPageScroll = () => {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.touchAction = '';
  };

  const isDismissed = () => safeGetStorage(localStorage, REMINDER_DISMISSED_KEY) === 'true';

  const dismissReminder = () => {
    safeSetStorage(localStorage, REMINDER_DISMISSED_KEY, 'true');
    stickyCheckoutModal.hidden = true;
    unlockPageScroll();
  };

  closeTriggers.forEach((node) => node.addEventListener('click', dismissReminder));
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || stickyCheckoutModal.hidden) return;
    dismissReminder();
  });
  if (ctaLink) {
    ctaLink.href = checkoutUrl;
    ctaLink.addEventListener('click', () => setCheckoutVisited());
  }

  const formatCurrency = (amountInCents, currencyCode) => {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode || (window.theme && window.theme.settings && window.theme.settings.currencyCode) || 'USD',
        
      }).format((amountInCents || 0) / 100);
    } catch (err) {
      return `£${((amountInCents || 0) / 100).toFixed(2)}`;
    }
  };

  /** One row per unique SKU; if SKU is missing/duplicate, fall back to variant_id. */
  const uniqueSkuLines = (items) => {
    const seen = new Set();
    const out = [];
    for (const item of items) {
      const sku = item.sku != null ? String(item.sku).trim() : '';
      const key = sku !== '' ? `sku:${sku}` : `variant:${item.variant_id}`;
      if (seen.has(key)) continue;
      seen.add(key);
      out.push(item);
    }
    return out;
  };

  const appendPhotoThumb = (item) => {
    const frame = document.createElement('div');
    frame.className = 'sticky-checkout-modal__thumb sticky-checkout-modal__thumb--photo';
    const inner = document.createElement('div');
    inner.className = 'sticky-checkout-modal__thumb-polaroid';
    const img = document.createElement('img');
    img.src = item.image || '';
    img.alt = item.product_title || item.title || 'Cart item';
    img.loading = 'lazy';
    inner.appendChild(img);
    frame.appendChild(inner);
    thumbsWrap.appendChild(frame);
  };

  const appendMoreThumb = (extraCount) => {
    const more = document.createElement('div');
    more.className = 'sticky-checkout-modal__thumb sticky-checkout-modal__thumb--more';
    const num = document.createElement('span');
    num.className = 'sticky-checkout-modal__more-num';
    num.textContent = `+${extraCount}`;
    const label = document.createElement('span');
    label.className = 'sticky-checkout-modal__more-label';
    label.textContent = 'More';
    more.appendChild(num);
    more.appendChild(label);
    thumbsWrap.appendChild(more);
  };

  const renderThumbs = (uniqueItems) => {
    if (!thumbsWrap) return;
    thumbsWrap.innerHTML = '';

    const n = uniqueItems.length;
    if (n === 0) {
      thumbsWrap.removeAttribute('data-thumb-layout');
      return;
    }

    if (n <= 4) {
      thumbsWrap.setAttribute('data-thumb-layout', `all-${n}`);
      uniqueItems.slice(0, n).forEach((item) => appendPhotoThumb(item));
    } else {
      thumbsWrap.setAttribute('data-thumb-layout', 'three-plus-more');
      uniqueItems.slice(0, 3).forEach((item) => appendPhotoThumb(item));
      appendMoreThumb(n - 3);
    }
  };

  const renderContent = (cart, uniqueItems) => {
    const lines = uniqueItems || uniqueSkuLines(cart.items || []);
    const uniqueCount = lines.length;

    if (countEl) {
      const countText =
        uniqueCount === 1 ? 'You have 1 item in your cart' : `You have ${uniqueCount} items in your cart`;
      countEl.textContent = countText;
    }

    if (totalEl) totalEl.textContent = formatCurrency(cart.total_price, cart.currency);

    renderThumbs(lines);
  };

  const showReminderIfEligible = async () => {
    if (hasPlacedOrder()) {
      clearCheckoutVisited();
      return;
    }

    if (!hasReachedCheckout() || isDismissed()) return;

    try {
      const response = await fetch(`${theme.routes.cart}.js`, { credentials: 'same-origin' });
      if (!response.ok) return;

      const cart = await response.json();
      if (!cart || !cart.item_count) {
        clearCheckoutVisited();
        return;
      }

      const uniqueItems = uniqueSkuLines(cart.items || []);
      if (!uniqueItems.length) {
        clearCheckoutVisited();
        return;
      }

      renderContent(cart, uniqueItems);
      stickyCheckoutModal.hidden = false;
      lockPageScroll();
    } catch (err) {
      // Fail silently and keep modal hidden on network errors.
    }
  };

  showReminderIfEligible();
})();
